import { JPBouvetMethodUrl } from '.'

export const validateToken = async (token) => {
	try {
		const response = await fetch(`${JPBouvetMethodUrl}/public-api/validate-jwt`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		})

		if (!response.ok) {
			throw new Error('Failed to validate token')
		}

		const data = await response.json()

		return data?.user_data?.isSubscriber ?? false
	} catch (error) {
		console.error('Error validating token:', error)
		return false
	}
}
